import { Component } from "react"
import PropTypes from "prop-types"

export default class SolutionLottieAnimation extends Component {
  componentDidMount() {
    const animationContainer = document.querySelector(
      "#" + this.props.animationId
    )
    window.lottie.loadAnimation({
      container: animationContainer, // the dom element that will contain the animation
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: this.props.lottieJson, // the path to the animation json
    })
  }
  render() {
    const { animationId, lottieJson } = this.props
    return <div id={animationId} data-lottie-json={lottieJson} />
  }
}

SolutionLottieAnimation.propTypes = {
  animationId: PropTypes.string.isRequired,
  lottieJson: PropTypes.string.isRequired,
}
